import { createSlice } from "@reduxjs/toolkit";

const featuresSlice = createSlice({
  name: "features",
  initialState: {
    announce: null,
    error: null
  },
  reducers: {
    announceRedux: (state, action) => {
      state.announce = action.payload;
    }
  }
});

export const { announceRedux } = featuresSlice.actions;
export default featuresSlice.reducer;
